import { DropDownList } from "@progress/kendo-react-dropdowns";
import {
  ACCOUNT_TYPES, FIA_PAYOUTS,
  NONQUAL_ACCOUNTS,
  PRETAX_ACCOUNTS,
  TAXFREE_ACCOUNTS,
} from "../../shared/constants";
import React from "react";

export const TaxTypeDropDownCell = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };
  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  if (!dataItem.inEdit) {
    return <td>
      {dataValue}
    </td>
  }

  return (
    <td>
      <DropDownList
        style={{
          width: "130px",
        }}
        onChange={handleChange}
        value={ACCOUNT_TYPES.find((c) => c.value === dataValue)}
        data={ACCOUNT_TYPES}
        textField="text"
      />
    </td>
  );
};

export const FIAPayoutDropDownCell = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };
  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] == null ? "LEVEL" : dataItem[field];

  if (!dataItem.inEdit) {
    return <td>
      {dataItem.annuityType === 'GUARANTEED_INCOME' && (dataValue)}
    </td>
  }

  return (
    <td>
      {dataItem.annuityType === 'GUARANTEED_INCOME' && (
        <DropDownList
          style={{
            width: "100px",
          }}
          onChange={handleChange}
          value={FIA_PAYOUTS.find((c) => c.value === dataValue)}
          data={FIA_PAYOUTS}
          textField="text"
        />
      )}
    </td>
  );
};

export const AccountTypeDropDownCell = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };

  const handleSetDefault = (e) => {
    props.onChange({
      dataIndex: 0,
      dataItem: props.dataItem,
      field: props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.value,
    });

  }

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  const options =
      (dataItem.taxType === "NON-QUALIFIED"
      ? NONQUAL_ACCOUNTS
      : dataItem.taxType === "PRE-TAX"
        ? PRETAX_ACCOUNTS
        : TAXFREE_ACCOUNTS).map(item => {
          let label = item.text;
          if (item.value === "TE_OTHER" && dataItem.accountTypeOtherName) {
            label = dataItem.accountTypeOtherName;
          }
          return {
            ...item,
            text: label,
          }
      });

  if (!dataItem.inEdit) {
    const selectedOption = options.find((c) => c.value === dataValue);
    return <td>
      {selectedOption.text}
    </td>
  }

  return (
    <td>
      <DropDownList
        style={{ width: '140px' }}
        value={options.find((c) => c.value === dataValue) === undefined ? handleSetDefault(options[0]) : options.find((c) => c.value === dataValue)}
        onChange={handleChange}
        data={options}
        textField="text"
      />
    </td>
  );
};
